import { Component, OnInit } from "@angular/core";
import { Observable, switchMap, map, defaultIfEmpty, isEmpty } from "rxjs";
import { FormGroup, UntypedFormGroup, FormBuilder } from "@angular/forms";
import {
  DataService,
  CustomDetailComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./product-stock-display.component.html",
})
export class ProductStockDisplayComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: UntypedFormGroup;

  totalStock$: Observable<number>;
  isNew = true

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.totalStock$ = this.entity$.pipe(
      switchMap((res, _) => {
        return this.dataService.product
          .getProductVariants({
            filter: {
              productId: {
                eq: res.id,
              },
            },
          })
          .mapStream(({ productVariants }) => productVariants.items)
          .pipe(
            map((items, _) => {
              let total = 0;
              for (const i of items) {
                const stock = i.stockLevels[0]?.stockOnHand ?? 0;
                total += stock;
              }

              return total;
            })
          );
      })
    );

    this.totalStock$.subscribe((s) => {
      this.isNew = false
    });

    // let test = this.entity$.pipe(isEmpty());

    // test.subscribe((x) => {
    //   console.log("wtf", x);
    // });
  }
}
